import { CSRF, getData, getElement } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { CategoryModal as Modal } from "./modals/store";

class CategoryModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
        const DtElement = getElement("[data-table=dt]", this);
        const BtnNew = getElement("[name=new]", this); // Identificar el botón para crear

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            scrollY: "520px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("categoriesUrlDt"),
            type: "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };
        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            { data: "code", width: "5%", className: "text-center" },
            { data: "name" },
            { data: "parent" },
            { data: "account", width: "20%" },
            {
                data: "status",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
        ];

        const DtAps = new Dt(configDt);
        DtAps.dataTable(DtElement);
        // End DataTable

        // Eventos
        BtnNew?.addEventListener("click", (e) => {
            Modal.create(
                getData(BtnNew, "data-bs-target"),
                getData(BtnNew, "title"),
                getData(BtnNew, "data-url")
            );
        });

        DtElement.addEventListener("click", (e) => {
            const BtnEdit = e.target.closest(".edit");

            if (BtnEdit) {
                Modal.edit(
                    getData(BtnEdit, "data-bs-target"),
                    getData(BtnEdit, "title"),
                    getData(BtnEdit, "data-url"),
                    getData(BtnEdit, "data-data")
                );
            }
        });
    }
}

window.customElements.define("category-module", CategoryModule, {
    extends: "section",
});
